import { render, staticRenderFns } from "./LocalDelivery.vue?vue&type=template&id=0a158213"
import script from "./LocalDelivery.vue?vue&type=script&lang=js"
export * from "./LocalDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports